import { Component, Input } from '@angular/core';
import { Coluna, FormatoExportacao, FuncaoService, Imovel, Login, Relatorio, ReavaliacaoImovelItem } from 'eddydata-lib';

@Component({
  selector: 'app-bem-imovel-reavaliacao',
  templateUrl: './bem-imovel-reavaliacao.component.html'
})
export class BemImovelReavaliacaoComponent {

  @Input() public login: Login;
  @Input() public entidade: Imovel;
  @Input() public reavaliacoes: ReavaliacaoImovelItem[];

  constructor(
    public funcaoService: FuncaoService) {
  }

  public exportarListagem(formato: FormatoExportacao) {
    if (formato === 'pdf') {
      Relatorio.imprimir(`Reavaliacoes do bem ${this.entidade.placa}`, this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao,
        this.reavaliacoes, this.colunas(), 'portrait', `Reavaliacoes do bem ${this.entidade.placa}`,
        ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto']);
    } else {
      this.funcaoService.exportar(formato, this.reavaliacoes, `Reavaliacoes do bem ${this.entidade.placa}`, this.colunas());
    }
  }

  private colunas(): Coluna[] {
    return [
      { titulo: 'Data', coluna: 'reavaliacao.data_efetivacao', alignment: 'center' },
      { titulo: 'Usuário', coluna: 'reavaliacao.usuario.nome' },
      { titulo: 'Processo', coluna: 'reavaliacao.processo', alignment: 'center' },
      { titulo: 'Anterior', coluna: 'valor_anterior', alignment: 'right', decimais: 2 },
      { titulo: 'Vida Útil Anterior (meses)', coluna: 'vida_util_meses_anterior', alignment: 'center' },
      { titulo: 'Vida Útil (meses)', coluna: 'vida_util_meses', alignment: 'center' },
      { titulo: 'Valor Residual Anterior', coluna: 'valor_residual_anterior', alignment: 'right', decimais: 2 },
      { titulo: 'Valor Residual', coluna: 'valor_residual', alignment: 'right', decimais: 2 },
      { titulo: 'Cotação 1', coluna: 'valor_cotacao1', alignment: 'right', decimais: 2 },
      { titulo: 'Cotação 2', coluna: 'valor_cotacao2', alignment: 'right', decimais: 2 },
      { titulo: 'Cotação 3', coluna: 'valor_cotacao3', alignment: 'right', decimais: 2 },
      { titulo: 'Reavaliação', coluna: 'valor_reavaliacao', alignment: 'right', decimais: 2 },
    ];
  }
}
